module.exports = __webpack_public_path__ + "assets/img/media_22.7e74e474.png";